import { render, staticRenderFns } from "./ExternalGyro.vue?vue&type=template&id=1efc79b2&"
import script from "./ExternalGyro.vue?vue&type=script&lang=js&"
export * from "./ExternalGyro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports